//dependencies
import { createRouter, createWebHistory } from "vue-router";

import { getCurrentUser } from "./firebase";
import { useAuthStore } from "./stores/auth.store";
import { getDriverShiftSchedule } from "./services/user.service";

const routes = [
	{
		path: "",
		component: () => import("./pages/index.vue"),
		meta: { requiresAuth: true, breadcrumbs: [], requiresShift: true },
	},
	{
		path: "/order/:taskID",
		component: () => import("./pages/order-details.vue"),
		props: true,
		meta: { requiresShift: true },
	},
	{
		path: "/login",
		component: () => import("./pages/login.vue"),
		meta: { hideNavbar: true, skipAuth: true },
	},
	{
		path: "/logout",
		component: () => import("./pages/logout.vue"),
		meta: { skipAuth: true, hideNavbar: true },
	},
	{
		path: "/profile",
		component: () => import("./pages/profile.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "/odometer-verification",
		component: () => import("./pages/odometer-verification.vue"),
		meta: { requiresAuth: true, hideNavbar: true },
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach(async (to) => {
	if (to.meta.skipAuth) {
		return true;
	}
	if (to.meta.requiresAuth) {
		const authStore = useAuthStore();

		// Wait for auth-init to finish before checking user state
		if (!authStore.isAuthReady) {
			await new Promise<void>((resolve) => {
				const interval = setInterval(() => {
					if (authStore.isAuthReady) {
						clearInterval(interval);
						resolve();
					}
				}, 50);
			});
		}

		const user = getCurrentUser();
		if (!user) {
			return router.push("/login");
		}
	}
	return true;
});

router.beforeEach(async (to) => {
	if (to.meta.requiresShift) {
		await getDriverShiftSchedule();
	}
	return true;
});

export default router;
